import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { VehicleService } from '../vehicle/vehicle.service';
import { AddVehiclesService } from './add-vehicles.service';

@Component({
  selector: 'app-add-vehicles',
  templateUrl: './add-vehicles.component.html',
  styleUrls: ['./add-vehicles.component.sass']
})
export class AddVehiclesComponent implements OnInit {
  vehicleType="";
  capacity="";
  isImageUploaded=false;
  vehicleDimentions_L = "";
  vehicleDimentions_B = "";
  vehicleDimentions_H = "";
  vehicleSize="";
  originalPrice="";
  discountPrice="";
  rating="";
  termsAndConditions="";
  labourAvailable=false;
  activeStatus=false;
  constructor(private toastr:ToastrService,
              private spinner : NgxSpinnerService,
              private addvehicelService:AddVehiclesService,
              private router:Router) { }

  ngOnInit(): void {
    this.getRange()
  }

  addVehicle(){
      let data = {
        "type": this.vehicleType,
        "vehicleCapacity" : this.capacity,
        "labourAvailable": this.labourAvailable,
        "originalPrice": this.originalPrice,
        "discountedPrice": this.discountPrice,
        "currentStatus": this.activeStatus == true? 1 : 0 ,
        "rating": this.rating,
        "vehicleSizeDimention" : this.vehicleDimentions_L + "X" + this.vehicleDimentions_B + "X" +this.vehicleDimentions_H ,
        "vehicleLength" : this.vehicleDimentions_L ,
        "vehicleBreadth" : this.vehicleDimentions_B ,
        "vehicleHeight" : this.vehicleDimentions_H ,
        "images" :  this.imageUrl,
        "vehicleSize" : this.vehicleSize, 
        "termsCondition" : this.termsAndConditions,
        "vehiclePrice":this.vehiclePrice
      }
      console.log(data)
      this.spinner.show();
      this.addvehicelService.addVehicle(data).subscribe((result:any)=>{
          if(result.statusCode == 200){
            this.spinner.hide()
            this.toastr.success(result.message);
            this.router.navigateByUrl('dashboard/vehicle');
          }else{
            this.spinner.hide()
            this.toastr.error(result.message);
          }
      })
  } 
  checkAllRangesUpdated() {
    if (this.vehiclePrice.length !== this.allRanges.length) {
      this.message='Please add prices for all ranges before proceeding.';
      this.messageType="error"
      console.log(this.vehiclePrice.length,  this.allRanges.length )
    }else if(this.vehiclePrice.length == this.allRanges.length){
      console.log(this.vehiclePrice.length,  this.allRanges.length )
      this.addVehicle()
    }else(this.toastr.warning("Somthing Went Wrong"))
  }
  
  
  allRanges:any[]=[]
  getRange(){
    this.spinner.show();
    this.addvehicelService.getAllRanges().subscribe((result:any)=>{
      this.spinner.hide();
      if(result.statusCode==200){
        console.log("allRange", result)
        this.allRanges=result.data
      }else(this.toastr.error(result.message))
    })
  }
  onRangeChange() {
    this.priceInput = null;
    this.discountedPriceInput = null;
    this.message=''
  }

  selectedRange: any = ''; // Holds the currently selected range
  priceInput: number | null = null; // Holds user input for price
  discountedPriceInput: number | null = null; // Holds user input for discountedPrice
  vehiclePrice: { min: number, max: number, price: number, discountedPrice: number }[] = [];  
  message: string = ''; // Variable to store status or error messages
  messageType: string = ''; // Holds the type of message ('success' or 'error')
  
  addVehiclePrice() {
    // Check if all fields are filled
    if (this.selectedRange && this.priceInput !== null && this.discountedPriceInput !== null) {
      // Check if discounted price is less than price
      if (this.discountedPriceInput >= this.priceInput) {
        this.message = 'Discount price must be less than the Price.';
        this.messageType = 'error'; // Set message type to error
        return; // Exit function
      }
  
      // Check if the range already exists
      const existingRangeIndex = this.vehiclePrice.findIndex(vp => 
        vp.min === this.selectedRange.min && vp.max === this.selectedRange.max
      );
  
      if (existingRangeIndex !== -1) {
        // If the range exists, update the price and discountedPrice
        this.vehiclePrice[existingRangeIndex].price = this.priceInput;
        this.vehiclePrice[existingRangeIndex].discountedPrice = this.discountedPriceInput;
        
        // Set success message
        this.message = `Price details updated for the selected range (${this.selectedRange.min} - ${this.selectedRange.max} KM).`;
        this.messageType = 'success'; 
      } else {
        // If the range does not exist, add it as a new entry
        const newPrice = {
          min: this.selectedRange.min,
          max: this.selectedRange.max,
          price: this.priceInput,
          discountedPrice: this.discountedPriceInput,
        };
  
        // Add the new price entry
        this.vehiclePrice.push(newPrice);
        this.message = `New range (${this.selectedRange.min} - ${this.selectedRange.max} KM) and price added.`;
        this.messageType = 'success'; 
      }
      console.log("Range With Price", this.vehiclePrice)
  
      // Sort the vehiclePrice array by min value
      this.vehiclePrice.sort((a, b) => a.min - b.min);
  
      // Clear inputs after adding
      this.priceInput = null;
      this.discountedPriceInput = null;
      this.selectedRange = ''; // Optionally reset the selected range
    } else {
      this.message = 'Please fill all fields before adding.';
      this.messageType = 'error'; 
    }
  }



  isValidImage: any;
  imageUrl = "";
  getVehicleImage(event , type) {
    if(type == "VEHICLE_IMAGE"){
      if (event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/jpg' || event.target.files[0].type == 'image/png') {
        this.isValidImage = false;
        this.addvehicelService.addImage(event.target.files[0]).subscribe((result:any)=>{
          console.log(result)
          if(result.statusCode == 200){
              this.isImageUploaded = true;
              this.imageUrl = result.photoUrl;
          }else{
            this.isImageUploaded = false;
            this.imageUrl = "";
          }
          this.isValidImage = false;
        })

    } else {
      this.isValidImage = true;
      this.isImageUploaded = false;
    }
  }
  }

  labourAvail(value){
    this.labourAvailable = value;
  }

  currentActiveStatus(value){
    this.currentActiveStatus = value;
  }
}
